var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadedWarehouses)?_c('CellsContentAdmin',{attrs:{"warehouseStorages":_vm.warehouseStorages},on:{"changeTab":_vm.changeTab}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }